angular
    .module('app')
    .factory('CollisService', function (CollisParserServiceApi) {
    let fac = {
        treeview: treeview,
        paginator: paginator
    };
    function treeview(traceId) {
        return CollisParserServiceApi.treeview(traceId);
    }
    function paginator(items, page, perPage) {
        perPage = perPage || 20;
        let totalPages = Math.ceil(items.length / perPage);
        page = page || 1;
        let offset = (page - 1) * perPage;
        let paginatedItems = _.drop(items, offset).slice(0, perPage);
        return {
            page: page,
            perPage: perPage,
            totalItems: items.length,
            totalPages: totalPages,
            data: paginatedItems
        };
    }
    return fac;
});
angular.module('app').component('collisViewer', {
    bindings: {
        traceId: '<',
        onSelect: '&'
    },
    controllerAs: 'vm',
    controller: function (toastr, CollisService) {
        let vm = this;
        vm.treeOptions = treeOptions;
        vm.collapse = collapse;
        vm.selectNode = selectNode;
        vm.applyFilter = applyFilter;
        vm.clearFilter = clearFilter;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.pageChanged = pageChanged;
        let cachedDataForTheTree = [];
        // Start at page 1
        vm.page = 1;
        // Show 20 nodes per page
        let numPerPage = 20;
        // Num pages to show in ui-pagination
        vm.maxSize = 10;
        // Flag to keep the treeview expanded as we page
        let keepExpanded = false;
        this.$onInit = function () {
            if (angular.isUndefined(this.traceId)) {
                toastr.error('TraceId is undefined');
            }
            vm.page = 1;
            // Show 20 nodes per page
            numPerPage = 20;
            // Num pages to show in ui-pagination
            vm.maxSize = 10;
            // Flag to keep the treeview expanded as we page
            keepExpanded = false;
        };
        // Cache the collis data
        this.$onChanges = function (changes) {
            if (changes.traceId) {
                vm.traceId = changes.traceId.currentValue;
            }
            CollisService.treeview(vm.traceId).then(function (response) {
                cachedDataForTheTree = response.data;
                pageChanged();
            });
        };
        function pageChanged() {
            let page = vm.paginator ? vm.paginator.page : 1;
            let paginator = CollisService.paginator(cachedDataForTheTree, page, numPerPage);
            vm.paginator = paginator;
            if (keepExpanded) {
                expand();
            }
            // console.table(paginator);
        }
        function clearFilter() { }
        function applyFilter(filterStr) {
            //console.log(filterStr);
        }
        function expand() {
            vm.expandedNodes = vm.paginator.data;
            keepExpanded = true;
        }
        function collapse() {
            vm.expandedNodes = [];
            keepExpanded = false;
        }
        // Handle selction of ya-treeview node
        function selectNode(node, $path) {
            // TODO: Implement storage of nodes
            //console.log(node, 'selectedNode');
            // let nodeStore = {
            //     selectedNode: node,
            //     expandedNodes: vm.expandedNodes,
            //     path: $path
            // };
            // NodeStoreService.put(nodeStore);
            let revPath = $path().map(function (node) {
                return node.label;
            });
            let path = revPath;
            // Restore the selected node
            this.onSelect({ node: node, path: path });
            vm.selectedNode = node;
        }
        function treeOptions() {
            return {
                nodeChildren: 'children',
                dirSelectable: true,
                injectClasses: {
                    ul: 'c-ul',
                    li: 'c-li',
                    liSelected: 'c-selected',
                    iExpanded: 'c-expanded',
                    iCollapsed: 'c-collapsed',
                    iLeaf: 'c-leaf',
                    label: 'c-label',
                    labelSelected: 'c-selected'
                }
            };
        }
    },
    templateUrl: 'scripts/app/components/collis-viewer.tpl.html'
});
